import { Navigate } from 'react-router-dom';
import { useGetDefaultInventoryQuery } from '@/api/inventories';

const Inventories = () => {
  const { data, isSuccess } = useGetDefaultInventoryQuery();
  // Avoid navigating before we know what the default
  // inventory is. After success, the default could
  // still be undefined, however.
  if (!isSuccess) {
    return null;
  }
  return <Navigate to={`/communities/${data.id}`} />;
};

export { Inventories };
